// extracted by mini-css-extract-plugin
export default {"wrapper":"Navbar_wrapper__uORbB"};